// src/pages/admin/Patients.js
import React, { useEffect, useState } from 'react';
import './Patients.css';
import Header from '../../components/Header';
import AdminSidebar from './AdminSidebar';
import Footer from '../../components/Footer';
import api from "../../api";
import * as XLSX from 'xlsx'; 
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useNavigate } from "react-router-dom"; // ⬅️ ADDED for redirect

export default function AdminPatients() {
  const [patients, setPatients] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const token = localStorage.getItem('token');
  const email = localStorage.getItem("userEmail"); // ⬅️ ADDED get stored email
  const navigate = useNavigate(); // ⬅️ ADDED navigate for redirection

  // Admin-only checks are handled globally by AdminRoute wrapper

  useEffect(() => {
    api.get('/admin/patients', {
        method: "GET",
      headers: {
          "Authorization": `Bearer ${token}`,
        },
        credentials: "include",
    })
    .then(res => setPatients(res.data.patients || []))
    .catch(console.error);
  }, [token]);

  const exportToExcel = () => {
  // Flatten and format patient data
  const excelData = patients.map((user) => {
    const base = {
      Name: user.fullName,
      Email: user.email,
      Gender: user.gender,
      Phone: user.phone,
      Profile_Image: user.profileImageUrl,
      Emergency_Name: user.emergencyName,
      Emergency_Phone: user.emergencyPhone,
      Emergency_Email: user.emergencyEmail,
      Complaint: user.complaint,
    };

    const reports = (user.reports || []).map((r, i) => ({
      [`Report_${i + 1}_Date`]: r.date,
      [`Report_${i + 1}_Notes`]: r.notes,
      [`Report_${i + 1}_Report_URL`]: r.report_url,
      [`Report_${i + 1}_Prescription_URL`]: r.prescription_url,
    }));

    return Object.assign(base, ...reports);
  });

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Patients");

  XLSX.writeFile(workbook, "patients.xlsx");
};
  
  const toggleExpand = (email) => {
    setExpanded(expanded === email ? null : email);
  };

  return (
    <>
    
      <Header />
      <div className="admin-layout">
      <div className="admin-body">
        <AdminSidebar />
        <div className="admin-content">
          <h2>All Clients</h2>
          <button onClick={exportToExcel} className="export-btn">Download Excel</button> 
          <table className="patients-table">
            <thead>
              <tr>
                <th>Client Name</th>
                <th>Email</th>
                <th>Complaint</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {patients.map((user) => (
                <React.Fragment key={user.email}>
                  <tr>
                    <td>{user.fullName}</td>
                    <td>{user.email}</td>
                    <td>{user.complaint}</td>
                    <td>
                      <button onClick={() => toggleExpand(user.email)}>
                        {expanded === user.email ? <FaChevronUp /> : <FaChevronDown />}
                      </button>
                    </td>
                  </tr>
                  {expanded === user.email && (
                    <tr className="expanded-row">
                      <td colSpan="4">
                        <div className="expanded-details">
                          <p><strong>Gender:</strong> {user.gender}</p>
                          <p><strong>Phone:</strong> {user.phone}</p>
                          <p><strong>Emergency Contact:</strong> {user.emergencyName} ({user.emergencyPhone}, {user.emergencyEmail})</p>
                          <p><strong>Profile Image:</strong><br />
                            <img src={user.profileImageUrl} alt="Profile" className="profile-image" />
                          </p>
                          <div className="report-section">
                            <h4>Reports:</h4>
                            {(user.reports || []).map((report, i) => (
                              <div key={i} className="report-entry">
                                <p><strong>Date:</strong> {report.date}</p>
                                <p><strong>Notes:</strong> {report.notes}</p>
                                <p>
                                  <a href={report.report_url} target="_blank" rel="noreferrer">View Report</a> |{' '}
                                  <a href={report.prescription_url} target="_blank" rel="noreferrer">View Prescription</a>
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      </div>
      <Footer />
    
    </>
  );
}
